import { darkTheme as theme, darkTheme } from '../dark'

export const MuiToggleButtonGroup = {
  groupedHorizontal: {
    '&:not(:first-child)': {
      borderLeft: '1px solid ' + darkTheme.palette.primary.light,
      marginLeft: 0,
      '&.Mui-selected': {
        borderLeft: '1px solid ' + theme.palette.secondary.main
      }
    }
  }
}
